import { jsx as _jsx } from "react/jsx-runtime";
import { ReactEditor, useSlate } from "slate-react";
import { TEXT_ALIGN_TYPES } from "../../../constants";
import { isBlockActive, toggleBlock } from "../../../helpers";
import { StyleControlButton } from "../../Molecules";
var BlockButton = function (_a) {
    var control = _a.control, last = _a.last;
    var editor = useSlate();
    var isFocused = ReactEditor.isFocused(editor);
    return (_jsx(StyleControlButton, { active: isBlockActive(editor, control.style, TEXT_ALIGN_TYPES.includes(control.style) ? "align" : "type"), onMouseDown: function (event) {
            event.preventDefault();
            toggleBlock(editor, control.style);
        }, Icon: control.Icon, label: control.label, isFocused: isFocused, testId: control.testId, last: last }));
};
export default BlockButton;
